var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { DialogContent, DialogTitle } from "@mui/material";
import { Dialog2 } from "../../../../misc/Dialog2";
import { SmoothActionBar } from "../../../../misc/SmoothActionBar";
import { useAsyncAction } from "nate-react-api-helpers";
import { api } from "../../../../api/API";
import { useContext, useState } from "react";
import { EditContext } from "../../../../misc/scroller/EditProvider";
import { useSyncedRef } from "../../../../misc/SyncedRef";
import { AutoComplete } from "./AutoComplete";
import { useProjectId } from "../ProjectName";
import { makeIdOrder } from "../../quote/openings/MoveSelectedOpenings";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function MoveSelectedOpenings(props) {
    const project = useProjectId();
    const edit = useContext(EditContext);
    const reloadRef = useSyncedRef(edit.reload);
    const submit = useAsyncAction((input) => __awaiter(this, void 0, void 0, function* () { yield api.openings.reSequence(input); reloadRef.current(); props.onDone(); }), []);
    const [value, setValue] = useState(null);
    const onSubmit = () => { if (!value)
        return; submit.callback({ project: project, idOrder: makeIdOrder({ selected: props.ids, startingSeqNumber: (value === null || value === void 0 ? void 0 : value.seqNumber) || 0, all: edit.dataRef.current.flatMap(v => v.rows) }) }); };
    return /*#__PURE__*/ _jsxs(Dialog2, { open: true, onClose: () => props.onCancel(), onEnterPress: onSubmit, children: [/*#__PURE__*/ _jsx(DialogTitle, { children: "Move Selected Openings" }), /*#__PURE__*/ _jsxs(DialogContent, { children: [/*#__PURE__*/ _jsx("div", { style: { height: 8 } }), /*#__PURE__*/ _jsx(AutoComplete, { label: "Select new starting sequence number", search: (s) => __awaiter(this, void 0, void 0, function* () {
                            const list = edit.dataRef.current.flatMap(d => d.rows);
                            return list.filter(v => {
                                if (v.seqNumber.toString().startsWith(s.toLowerCase()))
                                    return true;
                                return false;
                            });
                        }), value: value, equals: (a, b) => a.id === b.id, makeLabel: v => { return v.seqNumber.toString(); }, onSelect: setValue })] }), /*#__PURE__*/ _jsx(SmoothActionBar, { loading: submit.loading, error: submit.error, onCancel: () => props.onCancel(), onSubmit: onSubmit, actionName: "Update", submitDisabled: !value })] });
}
